import Axios from "axios";
import config from "configs/config";
import getText from "Translator";

const returnError = (err, lang) => {
  console.log(err);
  const data = {
    success: false,
    code: 5001,
    message: getText("generalerror", lang),
  };
  return data;
};
export const getQuestionsWithIds = async (lang, data, token) => {
  try {
    let url = config.apiserver + "/question/getquestionswithids/";
    let res = await Axios.post(url, data, {
      headers: {
        "x-access-token": token,
      },
    });

    return res.data;
  } catch (err) {
    return returnError(err, lang);
  }
};
export const getAllQuestions = async (lang, newDatas, token) => {
  try {
    const url = config.apiserver + "/question/getallquestions/";
    
    let res = await Axios.post(url, newDatas, {
      headers: {
        "x-access-token": token,
      },
    });
    return res.data;
  } catch (err) {
    return returnError(err, lang);
  }
};
export const addQuestionToPage = async (lang, newDatas, token) => {
  try {
    const url = config.apiserver + "/question/addquestiontopage/";
    
    let res = await Axios.post(url, newDatas, {
      headers: {
        "x-access-token": token,
      },
    });
    return res.data;
  } catch (err) {
    return returnError(err, lang);
  }
};

export const getPageQuestions = async (lang, newDatas, token) => {
  try {
    const url = config.apiserver + "/question/getpagequestions/";
    
    let res = await Axios.post(url, newDatas, {
      headers: {
        "x-access-token": token,
      },
    });
    return res.data;
  } catch (err) {
    return returnError(err, lang);
  }
};
export const getSubAnswers = async (lang, newDatas, token) => {
  try {
    const url = config.apiserver + "/question/getsubanswers/";
     let res = await Axios.post(url, newDatas, {
      headers: {
        "x-access-token": token,
      },
    });
    return res.data;
  } catch (err) {
    return returnError(err, lang);
  }
};

export const getConditionForVisible = async (lang, newDatas, token) => {
  try {
    const url = config.apiserver + "/question/getconditionforvisible/";
    
    let res = await Axios.post(url, newDatas, {
      headers: {
        "x-access-token": token,
      },
    });
    return res.data;
  } catch (err) {
    return returnError(err, lang);
  }
};
export const setConditionForVisible = async (lang, newDatas, token) => {
  try {
    const url = config.apiserver + "/question/setconditionforvisible/";

    let res = await Axios.post(url, newDatas, {
      headers: {
        "x-access-token": token,
      },
    });
    return res.data;
  } catch (err) {
    return returnError(err, lang);
  }
};

export const deleteQuestion = async (lang, newDatas, token) => {
  try {
    const url = config.apiserver + "/question/deletequestionfrompage/";
    
    let res = await Axios.post(url, newDatas, {
      headers: {
        "x-access-token": token,
      },
    });
    return res.data;
  } catch (err) {
    return returnError(err, lang);
  }
};

export const storeQuestion = async (lang, newDatas, excel, token) => {
  try {
    let url = config.apiserver + "/question/storequestion/";
    let res;
    if (newDatas.questionType === "DB" || newDatas.questionType === "DBS") {
      const formData = new FormData();
      formData.append("data", JSON.stringify(newDatas));
      formData.append("excel", excel);
      url = config.apiserver + "/question/storequestiondb/";
      res = await Axios.post(url, formData, {
        headers: {
          "x-access-token": token,
        },
      });
    } else {
      res = await Axios.post(url, newDatas, {
        headers: {
          "x-access-token": token,
        },
      });
    }
    

    return res.data;
  } catch (err) {
    return returnError(err, lang);
  }
};

export const updateQuestion = async (lang, newDatas, excel, token) => {
  try {
     let url = config.apiserver + "/question/updatequestion/";
    let res;
    if (newDatas.questionType === "DB" || newDatas.questionType === "DBS") {
      const formData = new FormData();
      formData.append("data", JSON.stringify(newDatas));
      formData.append("excel", excel);
      url = config.apiserver + "/question/updatequestiondb/";
      res = await Axios.post(url, formData, {
        headers: {
          "x-access-token": token,
        },
      });
    } else {
      res = await Axios.post(url, newDatas, {
        headers: {
          "x-access-token": token,
        },
      });
    }
    return res.data;
  } catch (err) {
    return returnError(err, lang);
  }
};
export const getNewQuestionCode = async (lang, newDatas, token) => {
  try {
    const url = config.apiserver + "/headline/";
    
    let res = await Axios.post(url, newDatas, {
      headers: {
        "x-access-token": token,
      },
    });
    return res.data;
  } catch (err) {
    return returnError(err, lang);
  }
};
export const updateAnswersRowNumbers = async (lang, newData, token) => {
  try {
    let url = config.apiserver + "/question/updateanswersrownumbers/";
    let res = await Axios.post(url, newData, {
      headers: {
        "x-access-token": token,
      },
    });
    return res.data;
  } catch (err) {
    return returnError(err, lang);
  }
};
export const updatePageQuestionRowNumbers = async (lang, newData, token) => {
  try {
    let url = config.apiserver + "/question/updatepagequestionrownumbers/";
    let res = await Axios.post(url, newData, {
      headers: {
        "x-access-token": token,
      },
    });
    return res.data;
  } catch (err) {
    return returnError(err, lang);
  }
};
export const updateQuestionContainer = async (lang, newData, token) => {
  try {
    let url = config.apiserver + "/question/updatequestioncontainer/";
    let res = await Axios.post(url, newData, {
      headers: {
        "x-access-token": token,
      },
    });
    return res.data;
  } catch (err) {
    return returnError(err, lang);
  }
};


export const updatePageQuestionContainerRowNumbers = async (lang, newData, token) => {
  try {
    let url = config.apiserver + "/question/updatepagequestioncontainerrownumbers/";
    let res = await Axios.post(url, newData, {
      headers: {
        "x-access-token": token,
      },
    });
    return res.data;
  } catch (err) {
    return returnError(err, lang);
  }
};

export const updateQuestionAllowCopy = async (lang, newData, token) => {
  try {
    let url = config.apiserver + "/question/updatequestionallowcopy/";

    let res = await Axios.post(url, newData, {
      headers: {
        "x-access-token": token,
      },
    });

    return res.data;
  } catch (err) {
    return returnError(err, lang);
  }
};

export const getTitleQuestionsForCondition = async (lang, newDatas, token) => {
  try {
    const url = config.apiserver + "/question/gettitlequestionsforcondition/";
    
    let res = await Axios.post(url, newDatas, {
      headers: {
        "x-access-token": token,
      },
    });
    return res.data;
  } catch (err) {
    return returnError(err, lang);
  }
};

export const deleteAnswerItem = async (lang, newDatas, token) => {
  try {
    const url = config.apiserver + "/question/deleteansweritem/";
    
    let res = await Axios.post(url, newDatas, {
      headers: {
        "x-access-token": token,
      },
    });
    return res.data;
  } catch (err) {
    return returnError(err, lang);
  }
};
export const getCapsuleQuestionsForCondition = async (
  lang,
  newDatas,
  token
) => {
  try {
    const url = config.apiserver + "/question/getcapsulequestionsforcondition/";
    
    let res = await Axios.post(url, newDatas, {
      headers: {
        "x-access-token": token,
      },
    });
    return res.data;
  } catch (err) {
    return returnError(err, lang);
  }
};
export const getCapsuleQuestionsForRelatedAnswers = async (
  lang,
  newDatas,
  token
) => {
  try {
    const url = config.apiserver + "/question/getcapsulequestionsforrelatedanswer/";
    
    let res = await Axios.post(url, newDatas, {
      headers: {
        "x-access-token": token,
      },
    });
    return res.data;
  } catch (err) {
    return returnError(err, lang);
  }
};
export const updateAnswerRelated = async (
  lang,
  newDatas,
  token
) => {
  try {
    const url = config.apiserver + "/question/updateanswerrelated/";
    
    let res = await Axios.post(url, newDatas, {
      headers: {
        "x-access-token": token,
      },
    });
    return res.data;
  } catch (err) {
    return returnError(err, lang);
  }
};


